module.exports = __webpack_public_path__ + "img/upload.34a6e39c.svg";